import { FormularData, FormularErrors } from '@/model/form-data'
import { replaceCommas } from '@/util/number.util';

export class FormValidationService {
  public static validateFormularData(data: FormularData, duration: number | null): FormularErrors {
    const formularErrors: FormularErrors = {}

    if (parseFloat(replaceCommas(data.volume)) <= 0 || isNaN(parseFloat(replaceCommas(data.volume)))) {
      formularErrors.volume = 'Bitte wählen Sie ein gültiges Volumen'
    }

    if (data.name.length === 0) {
      formularErrors.name = 'Bitte verwenden Sie einen gültigen Namen';
    }

    if (data.address.length === 0) {
      formularErrors.address = 'Bitte verwenden Sie eine gültige Adresse';
    }

    if (duration == null) {
      formularErrors.address = 'Adresse konnte nicht gefunden werden';
    }

    if (duration && duration > 3) {
      formularErrors.address = 'Wir fahren aus ökologischen Gründen nicht länger, als 1 Stunde. Keine Bestellung möglich.';
    }

    if (data.number.length === 0) {
      formularErrors.number = 'Bitte verwenden Sie eine gültige Telefonnummer';
    }

    return formularErrors;
  }
}
